import { render, staticRenderFns } from "./SubjectTemplateItemback.vue?vue&type=template&id=09fbd210&scoped=true"
import script from "./SubjectTemplateItemback.vue?vue&type=script&lang=js"
export * from "./SubjectTemplateItemback.vue?vue&type=script&lang=js"
import style0 from "./SubjectTemplateItemback.vue?vue&type=style&index=0&id=09fbd210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbd210",
  null
  
)

export default component.exports